import React from 'react'
export const CubeContext = React.createContext({
    cube:{ width: 0, height: 0}, container: {width: 0, height: 0}, windowWidth: 0, windowHeight: 0, transformCube: ''
});